<template>
    <Layout>
        <div class="bg-gray-50 py-12 md:py-20">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center mb-12 md:mb-16">
                    <h1 class="text-4xl sm:text-5xl font-extrabold text-[#00395a] tracking-tight">Other Institutions</h1>
                    <p class="mt-4 text-lg sm:text-xl text-black max-w-3xl mx-auto">
                        A list of other notable Lohana institutions and their contact information.
                    </p>
                </div>

                <div class="bg-white p-6 sm:p-8">
                    <div class="overflow-x-auto">
                        <table class="min-w-full divide-y divide-gray-300">
                            <thead class="bg-gray-100">
                                <tr>
                                    <th scope="col" class="px-6 py-3 text-left text-base font-medium text-[#00395a] uppercase tracking-wider">
                                        Institute Name
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-left text-base font-medium text-[#00395a] uppercase tracking-wider">
                                        Contact Details
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-for="(institution, index) in institutions" :key="index" class="hover:bg-gray-50 transition-colors">
                                    <td class="px-6 py-4 whitespace-normal text-base font-medium text-black text-left">
                                        {{ institution.name }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-normal text-base text-black text-left ">
                                        {{ institution.contact }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from './../layouts/LayoutView.vue'

export default {
  name: 'OtherInstitutionsPage',
  components: {
    Layout
  },
  data() {
    return {
      institutions: [
        { name: 'SHREE LOHANA MAHAPARISHAD', contact: '10, Khetwadi, 4th Lane, S. V. P. Road, Mumbai – 400 004. Telefax : 2387 7555' },
        { name: 'SHREE HALAI LOHANA MAHAJAN', contact: '6/10, Thakurdwar Road, Mumbai – 400 002. Tel. : 2382 4215/2382 1092 Fax : 2389 8502' },
        { name: 'SHREE LOHANA MAHAJAN WADI', contact: 'Near Shankar Temple, S. V. Road, Kandivali – (W), Mumbai – 400 067 Tel. : 2807 1685.' },
        { name: 'SHREE KACHHI LOHANA MAHAJAN (MUMBAI)', contact: '33, Darya Sthan Street, 1st Floor, Vadgadi, Masjid Bundar – (w), Mumbai – 400 009 Tel. : 2342 4259 / 2347 9046.' },
        // Add more institutions here if needed
      ]
    }
  }
}
</script>
